import { connect } from 'react-redux';
import NarrowByFilterContainer from '../../containers/Filters/NarowByFilterContainer';
import React from 'react';
import {ENTITIES_FILTER_SPECIFIC} from "../../constants";
import utils from "../../utils/utilities";

const filtersStateToProps = (state, ownProps) => {
    // first take what we have in URL, if nothing there, take the data from preferences
    let entities = state.user.preferences.filters.entitiesFilter;
    if (ownProps.urlParams && ownProps.urlParams.riskEntityIds) {
        entities = {
            ...entities,
            type: ENTITIES_FILTER_SPECIFIC,
            entitiesId: ownProps.urlParams.riskEntityIds
        }
    }

    let language = state.user.preferences.filters.languageFilter;
    if (ownProps.urlParams && ownProps.urlParams.languages) {
        language = utils.languageArrayToObject(ownProps.urlParams.languages);
    }
    return {
        ...ownProps,
        filtersState: {
            filters: {
                entities,
                pestle:   (ownProps.urlParams && ownProps.urlParams.pestle) || state.user.preferences.filters.pestleFilter,
                risk:     (ownProps.urlParams && ownProps.urlParams.level) || state.user.preferences.filters.riskFilter,
                days:     (ownProps.urlParams && ownProps.urlParams.noOfDays) || state.user.preferences.filters.daysFilter,
                language
            }
        }
    }
};

const FiltersContainer = connect(filtersStateToProps)(NarrowByFilterContainer)

export default FiltersContainer;


// WEBPACK FOOTER //
// ./src/scripts/containers/Filters/Filters.containers.jsx